import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Lock, Sparkles, ArrowRight } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

/** Modal shown when /generate-report or /reports/{id}/pdf returns 402 (no credits). */
const PaywallModal = ({ open, onOpenChange, balance = 0 }) => {
  const nav = useNavigate();
  const loc = useLocation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0F1C3F] border border-white/10 text-white max-w-md" data-testid="paywall-modal">
        <DialogHeader>
          <div className="w-12 h-12 rounded-full bg-[#FF6B6B]/15 flex items-center justify-center mb-3">
            <Lock className="w-6 h-6 text-[#FF6B6B]" />
          </div>
          <DialogTitle className="font-display text-xl">You're out of report credits</DialogTitle>
          <DialogDescription className="text-white/60">
            Each PDF download uses 1 credit. Buy as few as 1 or as many as 1,000 in a single purchase.
          </DialogDescription>
        </DialogHeader>

        <div className="bg-white/[0.04] border border-white/10 rounded-xl p-4 my-4 flex items-center justify-between">
          <div>
            <p className="text-xs text-white/40 uppercase tracking-wider">Current balance</p>
            <p className="text-2xl font-bold text-white">{balance}</p>
          </div>
          <Sparkles className="w-8 h-8 text-[#FFE66D]" />
        </div>

        <ul className="text-xs text-white/50 space-y-1 mb-2">
          <li>• ₹1,499 per credit (India)</li>
          <li>• 18% GST applied (India only)</li>
          <li>• International users billed $29.99 in USD via Stripe</li>
          <li>• Credits never expire</li>
        </ul>

        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)}
            className="text-white/60 hover:text-white hover:bg-white/5"
            data-testid="paywall-cancel-btn">
            Maybe later
          </Button>
          <Button onClick={() => nav("/checkout", { state: { from: loc.pathname } })}
            className="bg-[#4ECDC4] hover:bg-[#3db8b0] text-[#0A1029] font-semibold"
            data-testid="paywall-buy-btn">
            Buy credits <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PaywallModal;
